<template>
  <div class="xy-tinymce" :style="xyTinymceStyle">
    <div class="xy-tinymce__content" :style="xyTinymceContentStyle" v-html="convertedContent"></div>
  </div>
</template>

<script setup>
import { watch, ref, computed } from 'vue'
import { info, defaultProps } from './config'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const convertedContent = ref('')

const xyTinymceStyle = computed(() => {
  const style = {
    direction: props.language === 'ar' ? 'rtl' : 'ltr'
  }
  if (props.autoHeight) {
    // 自适应高度
    style.height = 'auto'
  }
  if (props.autoWidth) {
    // 自适应宽度
    style.width = 'auto'
  }
  return style
})

const xyTinymceContentStyle = computed(() => {
  const style = {}
  if (props.autoHeight) {
    // 自适应高度
    style.height = 'auto'
  }
  if (props.autoWidth) {
    // 自适应宽度
    style.width = 'auto'
  }
  style.wordBreak = props.wordBreak || 'break-all'
  return style
})

const convertPxFormat = (content) => {
  // 样式单位适配
  const contentWeight = window.innerWidth || 750
  const ratio = contentWeight / 750
  if (import.meta.env.VITE_APP_TAG !== 'H5') {
    return content
  } else {
    return content
      .replace(/(width|height)=['"](\d+)(['"])/g, (match, attr, value, suffix) => {
        return `${attr}="${value}px"${suffix}`
      })
      .replace(/(\d+)px/g, (match, p1) => {
        const num = Math.round(parseInt(p1) * ratio)
        return `${num}px`
      })
  }
}

watch(
  () => props.content,
  (newValue) => {
    if (newValue) {
      convertedContent.value = convertPxFormat(newValue)
    }
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.xy-tinymce {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .xy-tinymce__content {
    width: 100%;
    height: 100%;

    :deep(img) {
      display: inline-block;
      /* 避免全局样式对图像的影响 */
      max-width: 100%;
      height: auto;
      object-fit: fill;
      vertical-align: middle;
    }

    :deep(h1) {
      font-size: 2em;
      font-weight: bold;
      margin: 30px 0;
    }

    :deep(h2) {
      font-size: 1.5em;
      font-weight: bold;
      margin: 22px 0;
    }

    :deep(h3) {
      font-size: 1.2em;
      font-weight: bold;
      margin: 16px 0;
    }

    :deep(h4) {
      font-weight: bold;
      margin: 12px 0;
    }

    :deep(video) {
      width: 100%;
      height: auto;
    }

    :deep(ul) {
      margin: revert;
      padding: revert;
      list-style: revert;
    }

    :deep(ol) {
      margin: revert;
      padding: revert;
      padding-inline-start: 1.2em;
      font-weight: bold;
      list-style: revert;
    }
  }
}
</style>
